module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor_/compartment_knob_512_bake.png";